var map = {
	"./1.png": 67908,
	"./2.png": 53183,
	"./3.png": 99382,
	"./4.png": 65705,
	"./5.png": 41504,
	"./6.png": 22715,
	"./7.png": 1170,
	"./8.png": 30325,
	"./9.png": 18700,
	"./Amber.png": 1288,
	"./Apn.png": 26498,
	"./Ash Ketchum.png": 38922,
	"./Babli.png": 44091,
	"./Bianca.png": 23703,
	"./Black.png": 66920,
	"./Bob.png": 59592,
	"./Borek.png": 24148,
	"./Brian.png": 2309,
	"./Broruto.png": 30466,
	"./Calem.png": 81635,
	"./Calus.png": 97677,
	"./Carmen.png": 68979,
	"./Cinciri.png": 13208,
	"./Clemont.png": 78897,
	"./Cody.png": 29454,
	"./Dawn.png": 89563,
	"./Diana.png": 55836,
	"./Ethan.png": 86161,
	"./Ferguson.png": 3108,
	"./Fines.png": 43302,
	"./Fleur.png": 45331,
	"./Frostylina.png": 21400,
	"./Fuflin.png": 6105,
	"./Gerta.png": 18502,
	"./Ginger.png": 25529,
	"./Gladion.png": 25961,
	"./Gloria.png": 36389,
	"./Gotsu.png": 19111,
	"./Hector.png": 72942,
	"./Hilbert.png": 54899,
	"./Hilda.png": 74131,
	"./Jezz.png": 15450,
	"./Jimmy.png": 76835,
	"./Jonathan.png": 19662,
	"./Ketchy.png": 27903,
	"./Kris.png": 34690,
	"./Kyra.png": 50506,
	"./Lana.png": 25107,
	"./Leaf.png": 90253,
	"./Lillie.png": 74674,
	"./Lucas.png": 52797,
	"./Lyra.png": 33135,
	"./Mallow.png": 57153,
	"./Mangetino.png": 31365,
	"./May.png": 6666,
	"./Methan.png": 53190,
	"./Metsu.png": 13535,
	"./Moon.png": 70898,
	"./Nadja.png": 74207,
	"./Nate.png": 40123,
	"./Patricia.png": 61804,
	"./Polly.png": 86301,
	"./Pomi.png": 18748,
	"./Prophan.png": 60025,
	"./Pupin.png": 4215,
	"./Red.png": 20348,
	"./Ringo.png": 57760,
	"./Rosa.png": 92620,
	"./Saffire.png": 77907,
	"./Serena.png": 89885,
	"./Sky.png": 10374,
	"./Summer.png": 67706,
	"./Sussy.png": 39278,
	"./Trin.png": 97586,
	"./Volty.png": 81303,
	"./Yam.png": 90218,
	"./Zu.png": 85146,
	"./league/Adiha.png": 57494,
	"./league/Agent Smith.png": 78377,
	"./league/Alex.png": 22403,
	"./league/Anton.png": 2479,
	"./league/Beilin.png": 6330,
	"./league/Bizika.png": 32151,
	"./league/Blizzy.png": 27071,
	"./league/Boban.png": 53851,
	"./league/Bred.png": 28652,
	"./league/Bubla.png": 28005,
	"./league/Colora.png": 51141,
	"./league/Davison.png": 87045,
	"./league/Derik.png": 15414,
	"./league/Donovan.png": 20446,
	"./league/Dony.png": 10367,
	"./league/Dr. Raven.png": 15645,
	"./league/Edudant.png": 63768,
	"./league/Fan Zang.png": 656,
	"./league/Farmer Tom.png": 49206,
	"./league/Francimore.png": 39949,
	"./league/Fykis.png": 83405,
	"./league/Gejedli.png": 66099,
	"./league/Ghost Henry.png": 55468,
	"./league/Giruga.png": 88956,
	"./league/Gorogo.png": 90390,
	"./league/Graundy.png": 76195,
	"./league/Ha Jajan.png": 20720,
	"./league/Hala.png": 4567,
	"./league/Heidy.png": 77584,
	"./league/Helico.png": 9293,
	"./league/Hontenten.png": 74926,
	"./league/Hó Fušihó.png": 38004,
	"./league/Izaak.png": 99053,
	"./league/Jeager.png": 5001,
	"./league/Kahid.png": 22196,
	"./league/Kelvin.png": 41468,
	"./league/Kemil.png": 85441,
	"./league/Kevin.png": 23952,
	"./league/Lemerd.png": 15722,
	"./league/Lemred.png": 62368,
	"./league/Lenore.png": 71272,
	"./league/Lulan.png": 30913,
	"./league/Mindezeen.png": 68212,
	"./league/Mindireen.png": 91000,
	"./league/Mr. Gardenier.png": 30035,
	"./league/Nemo.png": 21340,
	"./league/Olaf.png": 70971,
	"./league/Olda.png": 32711,
	"./league/Piny.png": 44709,
	"./league/Pof. Jožko.png": 66479,
	"./league/Rebeca.png": 59079,
	"./league/Red Baron.png": 73282,
	"./league/Rowan.png": 75930,
	"./league/Rubla.png": 68981,
	"./league/Shadow.png": 80559,
	"./league/Silver.png": 48232,
	"./league/Sir Marquis.png": 49271,
	"./league/Swift.png": 96370,
	"./league/Tentanten.png": 112,
	"./league/Tentari.png": 78084,
	"./league/Tyson.png": 75516,
	"./league/Walter.png": 29618,
	"./league/Weird Bob.png": 30809,
	"./league/Zabu.png": 13459,
	"./league/Činčiro.png": 67029,
	"./players/default0.png": 64785,
	"./players/default1.png": 70920,
	"./players/default10.png": 39130,
	"./players/default11.png": 56707,
	"./players/default12.png": 55080,
	"./players/default13.png": 69297,
	"./players/default14.png": 28286,
	"./players/default15.png": 46599,
	"./players/default16.png": 26540,
	"./players/default17.png": 95637,
	"./players/default18.png": 66482,
	"./players/default19.png": 64347,
	"./players/default2.png": 7779,
	"./players/default20.png": 9931,
	"./players/default21.png": 46274,
	"./players/default22.png": 60281,
	"./players/default23.png": 44528,
	"./players/default24.png": 40399,
	"./players/default25.png": 71654,
	"./players/default26.png": 55421,
	"./players/default27.png": 17940,
	"./players/default28.png": 13235,
	"./players/default29.png": 62474,
	"./players/default3.png": 60026,
	"./players/default30.png": 9280,
	"./players/default31.png": 87401,
	"./players/default32.png": 72786,
	"./players/default33.png": 87611,
	"./players/default34.png": 23748,
	"./players/default35.png": 77645,
	"./players/default36.png": 47318,
	"./players/default37.png": 60607,
	"./players/default38.png": 30760,
	"./players/default39.png": 24625,
	"./players/default4.png": 83797,
	"./players/default40.png": 55025,
	"./players/default41.png": 15080,
	"./players/default42.png": 51939,
	"./players/default43.png": 46714,
	"./players/default44.png": 4661,
	"./players/default45.png": 21772,
	"./players/default46.png": 6599,
	"./players/default47.png": 18910,
	"./players/default48.png": 17801,
	"./players/default5.png": 47884,
	"./players/default6.png": 50535,
	"./players/default7.png": 98046,
	"./players/default8.png": 27561,
	"./players/default9.png": 49440,
	"./teamRocket/Archer.png": 53894,
	"./teamRocket/Ariana.png": 82219,
	"./teamRocket/Butch.png": 8959,
	"./teamRocket/Cassidy.png": 59129,
	"./teamRocket/James.png": 45239,
	"./teamRocket/Jessie.png": 32268,
	"./teamRocket/Meowth.png": 69131,
	"./teamRocket/Orm.png": 69907,
	"./teamRocket/Petrel.png": 74051,
	"./teamRocket/Proton.png": 76243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69837;